module.exports = __webpack_public_path__ + "img/1401451594.13bee382.jpg";